import request from '../index';
import {
  OnlineUserItem,
  Prize,
  PrizeType,
  RushGameData,
} from '@/components/features/casino/rush/types';

export interface RushBetBodyParams {
  amountType: number;
  gameId: string;
  roundId: string;
  timestamp: number;
  currency: string;
}

export interface RushBetResult {
  decrTimeLine: string;
  rewardAmount: number;
  rewardValue: PrizeType;
}

export const rushBet = async (data: RushBetBodyParams) =>
  await request<Prize>({
    url: '/api/game/rush/v3/bet',
    method: 'post',
    data,
  });

export const getRushBetRecords = async (data: {
  currentPage: number;
  gameId: string;
  pageSize: number;
  roundId: string;
}) => {
  return await request<RewardRecords>({
    url: '/api/game/rush/v3/bet-records',
    method: 'post',
    data,
  });
};

export interface RewardRecords {
  currentPage: number;
  gameId: number;
  pageSize: number;
  records: Prize[];
  roundId: string;
  total: number;
}

export const getCurrentRewardRecords = async (data: {
  currentPage: number;
  gameId?: string;
  pageSize: number;
  roundId?: string;
  rushId?: string;
}) => {
  return await request<RewardRecords>({
    url: '/api/game/rush/v3/user/reward-records',
    method: 'post',
    data,
  });
};

export const getRushInviterCode = async () => {
  return await request<{
    inviteCode: string;
  }>({
    url: '/api/game/rush/v3/user/inviter-code',
    method: 'POST',
  });
};
export const getRushGameInfo = () => {
  return request({
    url: '/api/game/rush/v3/current-info',
  });
};

export const getOnlineUser = () => {
  return request<OnlineUserItem>({
    url: '/api/game/rush/v3/online-user',
    method: 'post',
    data: {
      currentPage: 1,
      pageSize: 100,
    },
  });
};

interface ReferReward {
  uid: string;
  inviteType: number;
  total: string;
  available: string;
  currency: string;
}

export const getUserReferReward = () => {
  return request<ReferReward>({
    url: '/api/game/rush/v3/user/refer/reward',
    method: 'post',
  }).then((res) => {
    if (res?.status?.code === '0') {
      return res.data;
    } else {
      return {
        uid: '',
        inviteType: 0,
        total: '0',
        available: '0',
        currency: 'USDT',
      } as ReferReward;
    }
  });
};
